// Cross-app URL helpers for hive-ui. Env-detection mirrors auth/src/App.vue's
// getHiveUrl/getApiUrl pattern (hostname suffix → fully-qualified origin).

function hostname(): string {
    if (typeof window === 'undefined') return '';
    return window.location.hostname;
}

export function pricingUrl(): string {
    const h = hostname();
    if (h.includes('hive-staging.privacybee.com')) return 'https://staging.privacybee.com/pricing';
    if (h.includes('hive-dev.privacybee.com')) return 'https://dev.privacybee.com/pricing';
    if (h.includes('hive.privacybee.com')) return 'https://privacybee.com/pricing';
    return 'https://privacybee.test/pricing';
}

export function checkoutOrigin(): string {
    const h = hostname();
    if (h.includes('hive-staging.privacybee.com')) return 'https://checkout-staging.privacybee.com';
    if (h.includes('hive-dev.privacybee.com')) return 'https://checkout-dev.privacybee.com';
    if (h.includes('hive.privacybee.com')) return 'https://checkout.privacybee.com';
    return 'https://checkout.privacybee.test';
}

// Builds the cross-app upgrade URL. `returnTo` is the hive-relative path the user
// should return to if they dismiss the modal in checkout without picking a plan.
export function checkoutUpgradeUrl(licenseId: number, returnTo: string): string {
    const params = new URLSearchParams({
        mode: 'upgrade',
        license_id: String(licenseId),
        return_to: returnTo,
    });
    return `${checkoutOrigin()}/?${params.toString()}`;
}

// Builds the cross-app new-purchase URL. `select=1` tells checkout to open the select-plan
// modal on load (instead of the marketing /pricing page). `returnTo` is the hive-relative
// path to return to if the buyer dismisses the modal without choosing a plan. An optional
// promo code is carried through and auto-applied in checkout.
export function checkoutPurchaseUrl(returnTo: string, opts: { promo?: string } = {}): string {
    const params = new URLSearchParams({ select: '1', return_to: returnTo });
    if (opts.promo) params.set('promo', opts.promo.toUpperCase());
    return `${checkoutOrigin()}/?${params.toString()}`;
}

// Builds the cross-app purchase URL for buying a license to assign to a family member. Carries
// the contact id + name so checkout auto-assigns the new license on completion and shows
// "purchasing for {name}" wording; `select=1` opens the plan picker. `returnTo` is the hive path
// to return to (typically /family).
export function checkoutAssignUrl(contact: { id: number; name?: string }, returnTo: string): string {
    const params = new URLSearchParams({
        select: '1',
        assign_to_contact_id: String(contact.id),
        assign_to_name: contact.name ?? '',
        return_to: returnTo,
    });
    return `${checkoutOrigin()}/?${params.toString()}`;
}
